/**
 * 배너 관련 Write 작업 목차
 * 
 * - incrementBannerClickCount() - 배너 클릭 횟수 증가
 * - incrementBannerImpressionCount() - 배너 노출 횟수 증가
 */

import apiClient from "@/utils/api";

/**
 * 배너 클릭 횟수 증가
 * @param {Object} banner - 배너 객체 (id, source 포함)
 * @returns {Promise<void>}
 */
export async function incrementBannerClickCount(banner) {
  try {
    await apiClient.post(`/api/ad/${banner.source}/${banner.id}/click`);
  } catch (error) {
    console.error("배너 클릭 횟수 증가 오류:", error);
    throw error;
  }
}

/**
 * 배너 노출 횟수 증가
 * @param {Object} banner - 배너 객체 (id, source 포함)
 * @returns {Promise<void>}
 */
export async function incrementBannerImpressionCount(banner) {
  try {
    await apiClient.post(`/api/ad/${banner.source}/${banner.id}/impression`);
  } catch (error) {
    console.error("배너 노출 횟수 증가 오류:", error);
    throw error;
  }
}
